import styled from 'styled-components';

export const FinancingProposalFormsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: ${(props) => props.theme.palette.colors.white};
  padding: 24px;
  border-radius: 8px;
  /* Mesmo motivo do TableWrapperContainer: deixa o card encolher para a tabela
     rolar por dentro, em vez de o scroll vazar para a pagina. */
  min-height: 0;
  overflow: hidden;
`;

export const FinancingProposalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  align-items: center;
`;

export const FormSpacing = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.palette.colors.shadow};
  height: 20px;
`;
